<form>
  <div class="fz-dialog">
    <div class="fz-dialog__close">
      <button
        mat-icon-button
        (click)="close($event)"
        data-ga-value="close-promo-code-modal"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="fz-dialog__root">
      <div class="fz-dialog__picture">
        <picture>
          <img
            class="dialog-message__body__image"
            src="/shared/svg/promo_code_success.svg"
            alt="Promo code Success"
          />
        </picture>
      </div>
      <div class="fz-dialog__head">
        <h2 class="fz-dialog__head__title">
          Your promo code “{{ data.promoCode }}” is saved!
        </h2>
        <p class="fz-dialog__head__subtitle">
          Please login, or join us by creating your FantaZ account to link the
          promo code to you.
        </p>
      </div>
      <div class="fz-dialog__content"></div>
      <div class="fz-dialog__actions">
        <a
          mat-flat-button
          class="fz-button--medium"
          color="primary"
          data-ga-value="login-promo-code"
          href="/auth/login"
        >
          Login
        </a>
        <a
          mat-stroked-button
          class="fz-button--medium"
          color="primary"
          data-ga-value="sign-up-promo-code"
          href="/auth/sign-up"
        >
          Join Now
        </a>
      </div>
    </div>
  </div>
</form>
